export default[
    {
        path: '/fatura/cadastro',
        name: 'cadastra fatura', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/fatura/lista',
        name: 'lista fatura', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/fatura/editar/:id',
        name: 'editar fatura', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]